import styled from 'styled-components';

export const AdminFooterContainer = styled.footer`
  display: grid;
  padding-left: 7.9rem;
  padding-right: 2.2rem;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  width: 100%;
  height: 6rem;
  position: relative;
  z-index: 30;
  background: ${({ theme }) => theme.colors.grey[100]};
`;

export const FooterContent = styled.div``;

// TODO: These are temporary styled components, not sure what kind of content
// We'll have on the Admin Footer.
export const FooterPlacehoder = styled.p`
  justify-self: flex-start;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.grey[300]};
`;

export const FooterLeftContent = styled.p`
  justify-self: flex-end;
  color: ${({ theme }) => theme.colors.grey[300]};
  font-size: 0.93em;
`;
